export default __webpack_public_path__ + "static/image04-ff2d53f4487ec008dd24cfe41ed84a45.webp";